import React from 'react'

import PartyResultMap from '../../../models/PartyResultMap'
import OutcomeController from '../../../models/OutcomeController'
import CoalitionsList from './CoalitionsList'
import OutcomeList from './OutcomeList'

interface IProps {
  outcomes: PartyResultMap[]
}

class Governments extends React.Component<IProps> {
  public render(): JSX.Element {
    const { outcomes } = this.props

    if (!outcomes.length) {
      return <div>Simulating...</div>
    }

    const outcomeController = new OutcomeController(outcomes)
    const partiesByOutcome = outcomeController.partiesByOutcome()
    const coalitions = outcomeController.buildCoalitions()

    const numCoalitionResults = outcomeController.filterByResult([
      'minority',
      'tie'
    ]).length

    return (
      <div>
        <h3>Likely governments</h3>
        <p className="text-muted">170 seats required for majority</p>
        <div className="row">
          <div className="col-12 col-md-4">
            <OutcomeList
              outcomeCounts={partiesByOutcome['majority']}
              totalNumOutcomes={outcomes.length}
              header="Majority"
            />
            <OutcomeList
              outcomeCounts={partiesByOutcome['minority']}
              totalNumOutcomes={outcomes.length}
              header="Minority"
            />
            <OutcomeList
              outcomeCounts={partiesByOutcome['tie']}
              totalNumOutcomes={outcomes.length}
              header="Tie"
            />
          </div>
          {(OutcomeController.hasResult(partiesByOutcome, 'minority') ||
            OutcomeController.hasResult(partiesByOutcome, 'tie')) && (
            <div className="col-12 col-md-8">
              <CoalitionsList
                coalitionCounts={coalitions}
                header="Possible minority coalitions"
                numCoalitionResults={numCoalitionResults}
                totalNumOutcomes={outcomes.length}
              />
            </div>
          )}
        </div>
      </div>
    )
  }
}

export default Governments
